import Result from "@/core/common/Result";
import type { ILastTerm } from "@/core/store/contratos/types";
import { ignitionHttpClient } from "@/core/services/IgnitionHttpClient";
import { HttpStatusCode } from "@/core/services/protocols/types";
import {
  getGestaoContratosMockScenario,
  isGestaoContratosMockEnabled
} from "@FIN/views/gestaoContratos/mocks/gestaoTermosMockScenario";
import type { IContratosStatusApiEnvelope } from "./types";

const DEFAULT_ERROR = "Não foi possível obter o status dos termos no momento.";

function mockDelay(ms = 220): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export async function fetchContratoPendenteFromAPI(): Promise<
  Result<ILastTerm>
> {
  if (isGestaoContratosMockEnabled()) {
    try {
      await mockDelay();
      if (getGestaoContratosMockScenario() === "fail_status") {
        return Result.fail(DEFAULT_ERROR);
      }

      const { getMockLastTermForStatus } = await import(
        "@FIN/views/gestaoContratos/mocks/gestaoTermosMockPayloads"
      );

      return Result.ok(getMockLastTermForStatus());
    } catch {
      return Result.fail(DEFAULT_ERROR);
    }
  }

  try {
    const response = await ignitionHttpClient.get<IContratosStatusApiEnvelope>({
      url: "/api/v1/financas/termos-aceite/pendentes"
    });

    if (response.statusCode !== HttpStatusCode.success || !response.body) {
      return Result.fail(DEFAULT_ERROR);
    }

    const body = response.body;

    if (!body?.result) {
      return Result.fail(DEFAULT_ERROR);
    }

    return Result.ok(body.result);
  } catch {
    return Result.fail(DEFAULT_ERROR);
  }
}
